import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container_overlay: {
    zIndex: 3,
    width: '100%',
    height: '100%',
    position: 'absolute',
  },

  canvas_overlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    userSelect: 'none',
    zIndex: 100,
    top: 0,
    left: 0,
    pointerEvents: 'auto',
    backgroundColor: 'transparent',
  },

  bounding_box_diagnose: {
    border: '1.2px',
    background: 'transparent',
    position: 'absolute',
    cursor: 'pointer',
    zIndex: 1500,
  },

  menu_item_container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0px 4px 8px',
    margin: '4px 6px',
    textTransform: 'uppercase',
  },

  menu_item_icon: {
    marginLeft: '12px',
    width: '12px',
  },

  menu_item_text: {
    textTransform: 'uppercase',
    fontSize: theme.fonts.responsiveMedium,
  },

  lession_class: {
    textShadow: '0px 0px 3px rgb(0 0 0)',
    minWidth: '60px',
    height: '12px',
    position: 'absolute',
    zIndex: 1600,
  },

  box_index: {
    position: 'absolute',
    fontSize: theme.fonts.responsiveSmall,
    zIndex: 1600,
    color: '#dddddd',
    textShadow: '0px 0px 3px rgb(0 0 0)',
    margin: 0,
    height: 'min(1.2vh, 1rem)',
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  box_tomo: {
    position: 'absolute',
    fontSize: theme.fonts.responsiveSmall,
    zIndex: 40,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '18px',
  },

  tooltip_text: {
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveSmall,
  },

  '@keyframes breathable-scale': {
    '0%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.4)',
    },
    '100%': {
      transform: 'scale(1)',
    },
  },

  breathingBox: {
    animation: '$breathable-scale 1.8s ease-in-out infinite',
  },
}));
